import { Input, Radio, Switch, InputNumber, Select, Space, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { HeaderSection } from '../../../contract/types';

interface Props {
  section: HeaderSection;
  onChange: (s: HeaderSection) => void;
  fieldMetas: FieldMeta[];
}

export function HeaderEditor({ section, onChange, fieldMetas }: Props) {
  const patch = (p: Partial<HeaderSection>) => onChange({ ...section, ...p });

  const insertField = (fieldName: string) => {
    patch({ content: section.content + `{{${fieldName}}}` });
  };

  return (
    <div>
      <Input.TextArea
        value={section.content}
        onChange={(e) => patch({ content: e.target.value })}
        placeholder={"公司名称 / 标题文本，支持多行\n可使用 {{字段名}} 插入字段值"}
        autoSize={{ minRows: 2, maxRows: 6 }}
        style={{ marginBottom: 8 }}
      />
      {/* 统一「标签在上、控件在下」结构，同一行内所有控件顶部对齐 */}
      <Space size={12} wrap align="start">
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>插入字段</Typography.Text>
          <br />
          <Select
            size="small"
            style={{ width: 140 }}
            placeholder="选择字段"
            showSearch
            optionFilterProp="label"
            value={undefined}
            onChange={(v) => { if (v) insertField(v); }}
            options={fieldMetas.map((m) => ({ label: m.name, value: m.name }))}
          />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>对齐</Typography.Text>
          <br />
          <Radio.Group
            size="small"
            value={section.align}
            onChange={(e) => patch({ align: e.target.value })}
            optionType="button"
            options={[
              { label: '左', value: 'left' },
              { label: '中', value: 'center' },
              { label: '右', value: 'right' },
            ]}
          />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>加粗</Typography.Text>
          <br />
          <Switch size="small" checked={section.bold} onChange={(v) => patch({ bold: v })} />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>字号(px)</Typography.Text>
          <br />
          <InputNumber
            size="small"
            min={8}
            max={48}
            value={section.fontSizePx}
            onChange={(v) => patch({ fontSizePx: v })}
            placeholder="默认"
            style={{ width: 72 }}
          />
        </div>
      </Space>
    </div>
  );
}
